import getOr from 'lodash/fp/getOr'
import reject from 'lodash/fp/reject'
import { v4 as uuidv4 } from 'uuid'


// Action types
const ADD_NOTIFICATION = 'Notifications/ADD_NOTIFICATION'
const REMOVE_NOTIFICATION = 'Notifications/REMOVE_NOTIFICATION'

// Action creators
export const addNotification = payload => ({
    payload: { id: uuidv4(), ...payload },
    type: ADD_NOTIFICATION
})

export const removeNotification = payload => ({
    payload,
    type: REMOVE_NOTIFICATION
})

// Initial state
export const initialState = {
    list: []
}

// Selectors
export const selectList = getOr(initialState.list, 'notifications.list')

export default function reducer(state = initialState, action = {}) {

    switch (action.type) {

        case ADD_NOTIFICATION:
            return {
                ...state,
                list: [ ...state.list, action.payload ]
            }

        case REMOVE_NOTIFICATION:
            return {
                ...state,
                list: reject(
                    item => item.id === action.payload.id,
                    state.list
                )
            }

        default:
            return state
    }
}
